import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Single axios instance with credentials + bearer fallback
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveToken(t) {
  localStorage.setItem("tt_token", t);
}

export function clearToken() {
  localStorage.removeItem("tt_token");
}

export function getToken() {
  return localStorage.getItem("tt_token");
}
